import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";

function Layout() {
  return (
    <Router>
      <Navbar />

      {/* All routes go here */}
      <Routes>
        <Route path="/" element={<Home />} />
        </Routes>
      <Footer />
    </Router>
  )
}

export default Layout